import { Injectable } from '@angular/core';
import { OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GoogleAuthCallBack, GoogleUserProfile } from './google-sdk';


@Injectable({
  providedIn: 'root'
})

export class GoogleAuthService {

  //#endregion
  private userProfileSubject = new BehaviorSubject<any>(null);
  authStatus: Observable<any> = this.userProfileSubject.asObservable();
  constructor(private oauthService: OAuthService,
    private oauthStorage: OAuthStorage,
    private http: HttpClient) {
  }

  login() {
    this.oauthService.initLoginFlow();
  }

  public async isAuthBack(): Promise<GoogleAuthCallBack> {
    const _hash = window.location.hash.substring(1); // Remove the leading #
    const _params = new URLSearchParams(_hash);
    const accessToken = _params.get('access_token');
    const idToken = _params.get('id_token');
    const isCallBack: boolean = !!(accessToken && idToken);
    return new Promise<any>((resolve, reject) => {
      const callbackModel: GoogleAuthCallBack =
      {
        isCallBack: isCallBack,
        accessToken: accessToken,
        tokenId: idToken,
      };
      resolve(callbackModel);
    });
  }
  public async handleLoginCallback(authBack: GoogleAuthCallBack): Promise<void> {
    if (authBack.accessToken && authBack.tokenId) {
      // Store tokens in OAuthStorage
      this.oauthStorage.setItem('access_token', authBack.accessToken);
      this.oauthStorage.setItem('id_token', authBack.tokenId);
      const googleUser = await this.getUserProfile(authBack.accessToken);
      console.log('start next user', googleUser);
      this.userProfileSubject.next(googleUser);
    }
  }

  // private checkLoginStatus() {
  //   if (this.oauthService.hasValidAccessToken()) {
  //     const userInfo = this.oauthService.getIdentityClaims() as GoogleUserProfile; 
  //     this.userProfileSubject.next(userInfo);
  //   }
  // }

  logout() {
    this.oauthService.logOut();
    this.userProfileSubject.next(null);
  }
  private async getUserProfile(accessToken?: string): Promise<GoogleUserProfile> {
    accessToken = accessToken ? accessToken : this.oauthService.getAccessToken();
    const userInfoEndpoint = 'https://www.googleapis.com/oauth2/v3/userinfo';
    const rawProfile = await this.http.get(userInfoEndpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).toPromise();

    return rawProfile as GoogleUserProfile;
  }
}
